import React from 'react';
import { RotateCcw, GripVertical } from 'lucide-react';
import InfoButton from '../InfoButton';

interface ModelsHeaderProps {
  onResetAll: () => void;
}

const ModelsHeader: React.FC<ModelsHeaderProps> = ({ onResetAll }) => {
  return (
    <div className="flex-shrink-0 p-2 relative">
      {/* Drag Handle */}
      <div className="drag-handle absolute top-1.5 right-1.5 p-1 rounded opacity-40 hover:opacity-100 transition-opacity cursor-grab active:cursor-grabbing z-10">
        <GripVertical className="h-4 w-4 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300" />
      </div>

      {/* Title and Info on the left */}
      <div className="flex items-center gap-2 pr-16 flex-wrap">
        <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">Models</h3>
        <InfoButton title="Models card">
          <div>
            <div>
              <span className="font-medium text-gray-800 dark:text-gray-200">Goal:</span> Choose
              models and runs to include in analysis.
            </div>
            <div>
              <span className="font-medium text-gray-800 dark:text-gray-200">How:</span>
              <ul className="list-disc pl-4 mt-1 space-y-1">
                <li>Toggle models using the switches next to each model.</li>
                <li>Select runs using the circular run selectors for each date/time.</li>
                <li>To select the latest run for a model, click on the model name directly.</li>
                <li>Click on the model name again to clear all selections for that model.</li>
                <li>
                  Press{' '}
                  <span className="px-1 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                    Reset
                  </span>{' '}
                  to clear all selections.
                </li>
              </ul>
            </div>
            <div>
              <span className="font-medium text-gray-800 dark:text-gray-200">Note:</span> Only
              selected runs are fetched and shown in charts/heatmaps.
            </div>
          </div>
        </InfoButton>
      </div>

      {/* Controls positioned to avoid overlap with drag handle */}
      <div className="absolute top-1.5 right-7 flex items-center gap-1">
        <button
          onClick={onResetAll}
          className="flex items-center gap-1 px-2 py-1 text-xs bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded transition-colors text-gray-600 dark:text-gray-300"
          title="Reset All Selections"
        >
          <RotateCcw className="h-3 w-3" />
          Reset
        </button>
      </div>
    </div>
  );
};

export default ModelsHeader;
